import React, { FocusEvent, useState } from "react";
import Autocomplete, {
    createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import {
    StandardTextFieldProps,
    TextField,
    TextFieldProps,
} from "@material-ui/core";
import { FormikProps } from "formik";
// import  { Container } from './styles';

interface AutoCompleteProps extends Omit<StandardTextFieldProps, "onChange"> {
    handleSelectedChanged: (e: any, value: any) => void;
    handleOnInputChanges: (value: string) => void;
    getOptionSelected: (option: any, value: any) => boolean;
    getOptionLabel: (option: any) => string;
    handleOnBlur: (e: FocusEvent<HTMLInputElement>) => void;

    inputValue?: string;
    label?: string;
    name?: string;
    error?: any;
    options?: any[];
    helperText?: string;
    selectedValue?: any;
    disabled?: boolean;
}
const AutoCompleteComponent: React.FC<AutoCompleteProps> = ({
    handleOnInputChanges,
    handleSelectedChanged,
    handleOnBlur,
    getOptionLabel,
    getOptionSelected,
    options,
    inputValue,
    selectedValue,
    error,
    name,
    label,
    helperText,
    disabled = false,
    autoComplete,
    value,
    ...rest
}) => {
    return (
        <Autocomplete
            disabled={disabled}
            fullWidth
            openOnFocus={false}
            value={selectedValue}
            getOptionLabel={getOptionLabel}
            // Para não abrir as opções ao clicar no input
            onInputChange={(_, newInputValue) => {
                handleOnInputChanges(newInputValue);
            }}
            filterOptions={createFilterOptions({
                matchFrom: "any",
                ignoreCase: true,
                limit: 3,
                ignoreAccents: true,
            })}
            options={options}
            getOptionSelected={getOptionSelected}
            onChange={(event, value) => {
                handleSelectedChanged(event, value);
            }}
            clearOnBlur={false}
            renderInput={(params) => (
                <TextField
                    {...params}
                    value={value || ""}
                    label={label}
                    onBlur={(event: React.FocusEvent<HTMLInputElement>) => {
                        handleOnBlur(event);
                    }}
                    name={name}
                    helperText={helperText}
                    error={error}
                    autoComplete={autoComplete}
                />
            )}
        />
    );
};

export default AutoCompleteComponent;
